/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faStopwatch} from '@fortawesome/pro-duotone-svg-icons';

const ReportsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faStopwatch} {...props} />
);

export default ReportsIcon;
